// ✅ Custom Slugify Function
const slugify = (text) => {
    return text
        .toString()
        .normalize("NFD")                // Normalize accented characters
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .toLowerCase()                   // Convert to lowercase
        .trim()                          // Remove whitespace from ends
        .replace(/[^a-z0-9\s-]/g, "")    // Remove special characters
        .replace(/\s+/g, "-")            // Replace spaces with -
        .replace(/-+/g, "-");            // Remove multiple dashes
};

// ✅ Helper: Generate Random ID
const generateRandomId = () => {
    return Math.random().toString(36).substring(2, 10);
};

// ✅ Main Function: Convert to Product Structure
export const convertToProductStructure = (row, pricing, categories) => {
    const { entities } = pricing;
    const priceInfo = entities && entities.length > 0 ? entities[0] : {};

    // Generate slug from item name
    const slug = slugify(row.itemName);

    // Generate permalink
    const permalink = `https://www.myfurnituremecca.com/product/${slug}`;

    // Convert description to HTML <p> tags
    const descriptionHtml = `<p>${row.detailedDescription || ""}</p>`;

    // Handle images
    const images = (row.imageSet || []).map((img, index) => ({
        image_url: img.href,
        alt_text: "",
        title: "",
        link_url: "",
        description: "",
        // _id: "8idy9wep8d9wpe8dhp9e8"
    }));

    // Primary image
    const primaryImage = images.length > 0 ? images[0] : null;

    // Regular and Sale Price (from pricing data)
    const regularPrice = (priceInfo.totalNetPrice ? priceInfo.totalNetPrice * 4 : 0).toString();
    const salePrice = (priceInfo.totalNetPrice ? priceInfo.totalNetPrice * 2 : 0).toString();


    // Weight dimensions
    const weightDimension = row.friendlyDimensions || "";

    // ✅ Handle Color Attribute
    let attributes = [];
    let default_attributes = [];

    if (row.color && row.colorSwatch) {
        const attrId = generateRandomId();
        const optionId = generateRandomId();

        const colorOption = {
            name: row.color,
            value: row.colorSwatch,
            // _id: optionId 
        };

        attributes.push({
            // _id: attrId,
            name: "Select Color",
            type: "image",
            options: [colorOption]
        });

        default_attributes.push({
            // _id: attrId,
            name: "Select Color",
            type: "image",
            options: [colorOption]
        });
    }
    return {
        name: row.itemName,
        slug,
        permalink,
        type: "simple",
        status: "published",
        featured: 0,
        description: descriptionHtml,
        short_description: row.friendlyDescription || "",
        sku: row.sku,
        regular_price: regularPrice,
        discount: {
            is_discountable: 1,
            discount_type: "currency",
            discount_value: salePrice || "0"
        },
        sale_price: salePrice,
        tax_status: "taxable",
        tax_class: "",
        brand: row.brandName || "MECCA",
        manage_stock: {
            is_stock_manage: 1,
            location: "All Locations",
            quantity: 99,
            stock_status: "inStock"
        },
        allow_back_order: 0,
        sold_individually: 0,
        shipping_required: 0,
        shipping_taxable: 0,
        collection: [],
        attributes,
        default_attributes,
        menu_order: -1707,
        enable_review: 1,
        parent: 0,
        variations: [],
        categories: categories, // Add categories if needed
        tags: [{ _id: "689f7ed17a405f6c626fb4c6" }],
        images,
        image: primaryImage,
        gtin: row.upc || "0",
        mpn: row.upc || "0",
        ean: row.upc || "0",
        deal_of_month: 0,
        best_selling_product: 0,
        related_products: [],
        default_variation: null,
        average_rating: "5.0",
        rating_count: 5,
        weight_dimension: weightDimension,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        purchase_note: "",
        dimension_image: row.dimensionSketch
            ? {
                image_url: row.dimensionSketch,
                alt_text: "",
                title: "",
                link_url: "",
                description: "",
                // _id: generateRandomId()
            }
            : null,
        product_features: [], // You can map row.productDetails if needed
        product_tag: { _id: "689f7ed17a405f6c626fb4c6" },
        sale_tag: { _id: "689f7ed17a405f6c626fb4c6" },
        collectionId: 0,
        outSource: true,
        sourceId: "ashley",
        dyrc: {
            active: 0,
            image: "",
            orientation: "",
            categories: [],
            catType: ""
        },
        meta: {
            title: row.itemName,
            description: null,
            keywords: "",
            canonical_url: permalink,
            robots: "",
            og_title: row.itemName,
            og_description: null,
            og_image: images.length > 1 ? images[1].image_url : "",
            x_title: row.itemName,
            x_description: null,
            x_image: images.length > 1 ? images[1].image_url : "",
            schemaMarkup: {}
        }
    };
};







export const mainCategoriesAshley = [
    {
        name: "Outdoor",
        id: "1",
        fm_cat: {

        }
    },
    {
        name: "Kidsroom",
        id: "2",
        fm_cat: {

        },
        subCategories: [
            // {
            //     parentCategoryID: "KIDSFURNITURE",
            //     value: "KIDSANDNURSERYKIDSFURNITURETVSTANDSANDMEDIACENTERS",
            //     label: "TV Stands and Media Centers",
            //     fm_cat: {
            //         is_main: 0,
            //         uid: 58,
            //         name: "bunk-and-loft-beds",
            //         slug: "bunk-and-loft-beds"
            //     }
            // },
            // {
            //     parentCategoryID: "KIDSFURNITURE",
            //     value: "KIDSANDNURSERYKIDSFURNITUREMIRROREDDRESSERS",
            //     label: "Mirrored Dressers",
            //     fm_cat: {
            //         is_main: 0,
            //         uid: 58,
            //         name: "bunk-and-loft-beds",
            //         slug: "bunk-and-loft-beds"
            //     }
            // },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITUREBUNKBEDS",
                label: "Bunk Beds",
                fm_cat: {
                    is_main: 0,
                    uid: 58,
                    name: "bunk-and-loft-beds",
                    slug: "bunk-and-loft-beds"
                }
            },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITURENIGHTSTANDS",
                label: "Nightstands",
                fm_cat: {
                    is_main: 0,
                    uid: 60,
                    name: "Nightstands",
                    slug: "nightstands",
                }
            },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITUREDRESSERSANDCHESTS",
                label: "Dressers and Chests",
                fm_cat: {
                    is_main: 0,
                    uid: 59,
                    name: "Dressers & Chests",
                    slug: "dressers-and-chests",
                }
            },
            // {
            //     parentCategoryID: "KIDSFURNITURE",
            //     value: "KIDSANDNURSERYKIDSFURNITUREVANITIES",
            //     label: "Vanities",
            //     fm_cat: {
            //         is_main: 0,
            //         uid: 58,
            //         name: "bunk-and-loft-beds",
            //         slug: "bunk-and-loft-beds"
            //     }
            // },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITURESTORAGE",
                label: "Storage",
                fm_cat: {
                    is_main: 0,
                    uid: 107,
                    name: "Kids Bedroom Storage",
                    slug: "kids-bedroom-storage",
                }
            },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITUREHEADBOARDS",
                label: "Headboards",
                fm_cat: {
                    is_main: 0,
                    uid: 57,
                    name: "Kids Bed & Headboards",
                    slug: "kids-bed-and-headboards",
                }
            },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITUREDESKS",
                label: "Desks",
                fm_cat: {
                    is_main: 0,
                    uid: 61,
                    name: "Desk & Chairs",
                    slug: "desk-and-chairs",
                }
            },
            {
                parentCategoryID: "KIDSFURNITURE",
                value: "KIDSANDNURSERYKIDSFURNITUREBEDS",
                label: "Beds",
                fm_cat: {
                    is_main: 0,
                    uid: 57,
                    name: "Kids Bed & Headboards",
                    slug: "kids-bed-and-headboards",
                }
            }
        ]
    },
    {
        name: "Home Office",
        id: "3",
        fm_cat: {
            is_main: 1,
            uid: 67,
            name: "Accent Furniture",
            slug: "accent-furniture"
        },
        subCategories: [
            {
                parentCategoryID: "HOMEOFFICE",
                value: "HOMEOFFICEHOMEOFFICEANDSTUDY",
                label: "Home Office and Study",
                fm_cat: {
                    is_main: 0,
                    uid: 48,
                    name: "Home Office",
                    slug: "home-office"
                }
            }
        ]
    },
    {
        name: "Rugs",
        id: "4",
        fm_cat: {

        },
        subCategories: [
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "RUGSANDDECORRUGSINDOOR/OUTDOORRUGS",
                label: "Indoor/Outdoor Rugs",
                fm_cat: {
                    is_main: 0,
                    uid: 49,
                    name: "Indoor / Outdoor Rugs",
                    slug: "indoor-outdoor-rugs",
                }
            },
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "RUGSANDDECORRUGSRUNNERRUGS",
                label: "Runner Rugs",
                fm_cat: {
                    is_main: 0,
                    uid: 50,
                    name: "Runners",
                    slug: "runners",
                }
            },
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "RUGSANDDECORRUGSWASHABLE",
                label: "Machine Washable",
                fm_cat: {
                    is_main: 0,
                    uid: 46,
                    name: "Machine Washable",
                    slug: "machine-washable",
                }
            },
            // {
            //     parentCategoryID: "RUGSANDDECOR",
            //     value: "RUGSANDDECORRUGSACCENTRUGS",
            //     label: "Accent Rugs",
                // fm_cat: {
                //     is_main: 0,
                //     uid: 53,
                //     name: "Shop All Rugs",
                //     slug: "shop-all-rugs",
                // }
            // }
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "RUGSANDDECORRUGSAREARUGS",
                label: "Area Rugs",
                // fm_cat: {
                //     is_main: 0,
                //     uid: 51,
                //     name: "Small Area Rugs",
                //     slug: "small-area-rugs",
                // }
                fm_cat: {
                    is_main: 0,
                    uid: 53,
                    name: "Shop All Rugs",
                    slug: "shop-all-rugs",
                }
            },

        ]
    },
    {
        name: "Mattresses",
        id: "5",
        fm_cat: {

        },
          subCategories: [
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "MATTRESSESANDBEDDINGMATTRESSESBYSIZEKING",
                label: "King",
                fm_cat: {
                    is_main: 0,
                    uid: 45,
                    name: "King",
                    slug: "king",
                }
            },
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "MATTRESSESANDBEDDINGMATTRESSESBYSIZECALIFORNIAKING",
                label: "California King",
                fm_cat: {
                    is_main: 0,
                    uid: 37,
                    name: "California King",
                    slug: "california-king",
                }
            },
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "MATTRESSESANDBEDDINGMATTRESSESBYSIZETWINXL",
                label: "Twin XL",
                fm_cat: {
                    is_main: 0,
                    uid: 46,
                    name: "Machine Washable",
                    slug: "machine-washable",
                }
            },
            // {
            //     parentCategoryID: "RUGSANDDECOR",
            //     value: "RUGSANDDECORRUGSACCENTRUGS",
            //     label: "Accent Rugs",
                // fm_cat: {
                //     is_main: 0,
                //     uid: 53,
                //     name: "Shop All Rugs",
                //     slug: "shop-all-rugs",
                // }
            // }
            {
                parentCategoryID: "PATIOACCESSORIES",
                value: "RUGSANDDECORRUGSAREARUGS",
                label: "Area Rugs",
                // fm_cat: {
                //     is_main: 0,
                //     uid: 51,
                //     name: "Small Area Rugs",
                //     slug: "small-area-rugs",
                // }
                fm_cat: {
                    is_main: 0,
                    uid: 53,
                    name: "Shop All Rugs",
                    slug: "shop-all-rugs",
                }
            },

        ]
    },
];